import React from 'react';
import './UnitedPlaceholder.css';

/* Same hero frame as the United page (shared .united-placeholder styles —
   ProjectReveal's border choreography keys off that class), holding the deck's
   cover slide as the reveal hero. */
const PolymarketPlaceholder: React.FC = () => {
  return (
    <div className="united-placeholder">
      <img
        src="/polymarket-cover.png"
        alt="A Few Ideas for Polymarket — deck cover"
        className="united-image"
        data-reveal-hero
      />
    </div>
  );
};

export default PolymarketPlaceholder;
